var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentoAFirmarNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.04,
    height: 34.33,
    viewBox: "0 0 30.04 34.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #316094;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictograma_-_Documentos_a_Firmar",
    "data-name": "Pictograma - Documentos a Firmar",
    transform: "translate(-923.314 -172.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pictograma_-_Documentos_a_Firmar-2",
    "data-name": "Pictograma - Documentos a Firmar",
    className: "cls-1",
    d: "M944.384,177.972a6.03,6.03,0,0,0-1.28-2.15,4.353,4.353,0,0,0-.48-.48,6.292,6.292,0,0,0-2.14-1.28,6.116,6.116,0,0,0-2.15-.38h-.01a6.274,6.274,0,0,0-2.13.37,6.155,6.155,0,0,0-2.15,1.27,3.933,3.933,0,0,0-.5.5,6.031,6.031,0,0,0-1.28,2.15h-8.95v30.04h30.04v-30.04Zm6.83,27.9h-25.75v-25.75h6.42c0-.07.01,0,.01,0h2.14a1.619,1.619,0,0,1,.01-.22,4.1,4.1,0,0,1,.57-1.93,4.326,4.326,0,0,1,1.58-1.57,4.264,4.264,0,0,1,2.13-.57h.01a4.3,4.3,0,0,1,4.28,4.29h8.6Z",
    transform: "translate(0 -0.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2114",
    "data-name": "Rect\\xE1ngulo 2114",
    className: "cls-1",
    width: 12.87,
    height: 2.15,
    transform: "translate(929.755 196.401)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2115",
    "data-name": "Rect\\xE1ngulo 2115",
    className: "cls-1",
    width: 17.17,
    height: 2.14,
    transform: "translate(929.754 189.971)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2116",
    "data-name": "Rect\\xE1ngulo 2116",
    className: "cls-1",
    width: 17.17,
    height: 2.14,
    transform: "translate(929.754 183.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4577",
    "data-name": "Trazado 4577",
    className: "cls-1",
    d: "M936.717,179.569a1.608,1.608,0,1,1,1.607,1.607,1.608,1.608,0,0,1-1.607-1.607",
    transform: "translate(0 -0.88)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentoAFirmarNormal);
export default __webpack_public_path__ + "static/media/documentoAFirmarNormal.b83dd1109a970f1fdbeeb291ca902886.svg";
export { ForwardRef as ReactComponent };